import { makeStyles } from "@material-ui/core/styles";
import * as colors from "../../../../theme/colors";

const useStyles = makeStyles(() => ({
  headerContainer: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: "24px",
    textAlign: "center",
    marginTop: 15,
    marginBottom: 15,
    color: colors.darkBlue900,
  },

  tabContainer: {
    display: "grid",
    gridTemplateColumns: "200px auto",
    alignItems: "start",
  },

  tabControl: {
    display: "flex",
    flexDirection: "column",
  },

  tabElementContainer: {
    // width: 100% must not add the padding and border on top of the grid track.
    boxSizing: "border-box",
    padding: '24px 32px 16px',
    borderRadius: 12,
    borderTopLeftRadius: 0,
    border: `1px solid ${colors.ideGrey200}`,
    width: "100%",
  },
}));

export { useStyles };
